import { gql, TypedDocumentNode } from '@apollo/client';

import { AuthorType } from '@shared/components/magazin/types';

import { GHOST_AUTHOR_FRAGMENT } from '../fragments/ghost-author';

export const GET_GHOST_AUTHOR_BY_SLUG: TypedDocumentNode<{ getGhostAuthorBySlug: AuthorType }> = gql`
  query getGhostAuthorBySlug($slug: String!) {
    getGhostAuthorBySlug(slug: $slug) {
      ...GhostAuthor
    }
  }
  ${GHOST_AUTHOR_FRAGMENT}
`;
